'use client'

import { useRouter } from 'next/navigation'
import Link from 'next/link'

const PioneersFooter = () => {
  const router = useRouter()


  return (
    <>
      <footer className="relative z-10 border-t border-white/10 bg-[#050510] py-10">
        <div className="mx-auto w-full max-w-lg px-4 pc:max-w-7xl pc:px-6">
          <div className="flex flex-col w-full items-start justify-between gap-4">
            <div className="flex flex-row w-full items-center justify-between pb-4 border-b border-white/20 gap-1">
              <button className="cursor-pointer" onClick={() => router.push('/')}>
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/footer_logo_ktechpioneers_white.png"
                  className="h-[36px] w-auto object-contain"
                  alt="K-TECH PIONEERS"
                />
              </button>
              <div className="flex flex-row items-center justify-center gap-2">
                <Link
                  href="https://www.instagram.com/ktechpioneers/"
                  target="_blank"
                  className="flex flex-row items-center justify-center w-[32px] h-[32px] bg-white rounded-full">
                  <img src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/icon_instagram_logo.png" className="w-6 h-auto object-contain" alt="인스타그램 url" />
                </Link>
                <Link
                  href="https://www.linkedin.com/showcase/k-tech-pioneers/"
                  target="_blank"
                  className="flex flex-row items-center justify-center w-[32px] h-[32px] bg-white rounded-full">
                  <img src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/icon_linkedin_logo.png" className="w-full h-full object-contain" alt="링크드인 url" />
                </Link>
                <Link
                  href="https://www.facebook.com/people/K-%ED%85%8C%ED%81%AC-%ED%8C%8C%EC%9D%B4%EC%98%A4%EB%8B%88%EC%96%B4%EC%A6%88/61572332398871/?mibextid=wwXIfr&rdid=xqbcopVrkivmvkrG&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1JUG2hXNSn%2F%3Fmibextid%3DwwXIfr"
                  target="_blank"
                  className="flex flex-row items-center justify-center w-[32px] h-[32px] bg-white rounded-full">
                  <img src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/icon_facebook_logo.png" className="w-full h-full object-contain" alt="링크드인 url" />
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-start justify-center gap-4">
              <div className="flex flex-row items-center justify-start w-full gap-3 pc:gap-4">
                <Link
                  href="/my/term-of-service"
                  target="_blank"
                  className="flex flex-row items-center gap-2">
                  <p className="text-base text-[#B8B8B8] pc:text-white">Terms of Use</p>
                </Link>
                <div className="h-[12px] w-px bg-[#B8B8B8] pc:bg-white"></div>
                <Link
                  href="/my/privacy-policy"
                  target="_blank"
                  className="flex items-center gap-2">
                  <p className="text-base text-[#B8B8B8] pc:text-white">Privacy Policy</p>
                </Link>
              </div>
              <div className="flex flex-col items-start justify-center gap-2 pc:gap-4">
                <h6 className="text-sm pc:text-base text-[#B8B8B8] pc:text-white">contact us : ktechpioneers.contact@gmail.com</h6>
                <p className="text-xs pc:text-sm text-[#B8B8B8] pc:text-white">COPYRIGHT © 2026 K-Tech Pioneers. ALL RIGHTS RESERVED.</p>
              </div>
              <div className="flex flex-row items-center justify-start gap-2 pc:gap-5">
                <div className="flex flex-row items-center justify-center">
                  <img
                    src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/partner_main.png"
                    className="pc:h-[30px] h-[20px] w-auto object-contain"
                    alt="과학기술정보통신부"
                  />
                </div>
                <div className="flex flex-row items-center justify-center">
                  <img
                    src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/partner_nipa.png"
                    className="pc:h-[30px] h-[20px] w-auto object-contain"
                    alt="NIPA 정보통신산업진흥원"
                  />
                </div>
                <div className="flex flex-row items-center justify-center">
                  <img
                    src="https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers/partner_logo_likelion.png"
                    className="pc:h-[15px] h-[10px] w-auto object-contain"
                    alt="멋쟁이사자처럼"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default PioneersFooter
